import styled from 'styled-components';

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;
